module.exports = __webpack_public_path__ + "media/crypto/crv-5431a93f.png";